/**
 * Ссылки на каналы и сообщения — в формате Discord: /channels/<сервер или @me>/<канал>[/<сообщение>].
 * Здесь только сборка и разбор адресов, без сторов: эти функции проверяет web/scripts/navigation.test.mjs.
 */

export interface ChannelLink {
  /** null — личные сообщения (@me). */
  guildId: string | null
  channelId: string
  messageId: string | null
}

export type AppLink = ({ kind: 'channel' } & ChannelLink) | { kind: 'invite'; code: string }

/** Ссылки на основной домен открываются внутри приложения, даже если оно запущено с другого адреса. */
const OWN_HOSTS = ['klichat.ru', 'www.klichat.ru']

/** Ссылка на канал, а с messageId — на сообщение в нём. */
export function channelLink(origin: string, guildId: string | null, channelId: string, messageId?: string | null): string {
  return `${origin}/channels/${guildId ?? '@me'}/${channelId}${messageId ? `/${messageId}` : ''}`
}

/** Что открыть по пути адреса: канал, сообщение или приглашение; остальное — не наше, null. */
export function parseAppPath(pathname: string): AppLink | null {
  const ch = /^\/channels\/(@me|\d{1,20})\/(\d{1,20})(?:\/(\d{1,20}))?\/?$/.exec(pathname)
  if (ch?.[1] && ch[2]) return { kind: 'channel', guildId: ch[1] === '@me' ? null : ch[1], channelId: ch[2], messageId: ch[3] ?? null }
  const invite = /^\/invite\/([A-Za-z0-9]{2,32})\/?$/.exec(pathname)
  if (invite?.[1]) return { kind: 'invite', code: invite[1] }
  return null
}

/** Ссылка из сообщения: свой адрес или klichat.ru ведут внутрь приложения, чужие сайты — null. */
export function parseAppLink(href: string, origin: string): AppLink | null {
  let url: URL
  try {
    url = new URL(href, origin)
  } catch {
    return null
  }
  const own = url.origin === origin || (url.protocol === 'https:' && OWN_HOSTS.includes(url.hostname))
  return own ? parseAppPath(url.pathname) : null
}
